import React from 'react';
import { useHistory } from 'react-router-dom';
import { useCurrentClientManager } from '../../context';
import { ClientModel, EntityModel } from '../../models';
import { trackEvent } from '../../utils';
import { BlockedModal } from './BlockedModal';
import { BlockedPage } from './BlockedPage';
const viewComponent = {
    modal: BlockedModal,
    page: BlockedPage,
};
export const BlockedAccountLevelView = ({ closeModal, modalRefs, modalStyles, path, requiredAccountLevels, variant, }) => {
    const ViewComponent = viewComponent[variant];
    const { actions: { changeView }, client, entity, selectedAccountLevel, } = useCurrentClientManager();
    // The first account level in the list is used to determine which account the user will switch to.
    const requiredAccountLevel = requiredAccountLevels[0];
    const requiredAccount = requiredAccountLevel === 'entity' && entity ? entity : client;
    const analyticsMetadata = {
        path,
        requiredAccountLevel,
        selectedAccountLevel,
    };
    const history = useHistory();
    const handleChangeViewClick = async () => {
        trackEvent(`Click - blocked segment-agnostic view - ${variant} - change view button`, analyticsMetadata);
        const updateSucceeded = await changeView({
            client: requiredAccountLevel === 'client' && requiredAccount instanceof ClientModel
                ? requiredAccount
                : client,
            entity: requiredAccountLevel === 'entity' && requiredAccount instanceof EntityModel
                ? requiredAccount
                : undefined,
        });
        if (updateSucceeded && variant === 'modal') {
            closeModal?.();
            history.push(path);
        }
    };
    return (React.createElement(ViewComponent, { analyticsMetadata: analyticsMetadata, closeModal: closeModal, modalRefs: modalRefs, modalStyles: modalStyles, onChangeViewClick: handleChangeViewClick, requiredAccountName: requiredAccount.name }));
};
